<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>account_balance_wallet</mat-icon></div>
    <div class="ef-header-text">
      <h2 class="cf-dlg-title">{{ isEditMode ? 'Editar caja' : 'Nueva caja' }}</h2>
      <p class="cf-dlg-subtitle">
        {{ isEditMode && efectivo.accountingModelsNumber ? 'Cuenta contable ' + efectivo.accountingModelsNumber : 'Se creará su cuenta contable 570 automáticamente' }}
      </p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="saving" [message]="isEditMode ? 'Actualizando caja…' : 'Creando caja…'"></app-loading-state>

  <form *ngIf="!saving" class="ef-form" (ngSubmit)="save()" novalidate>
    <div class="cf-dlg-body">
      <div class="cf-dlg-mismatch" *ngIf="saveError">
        <mat-icon>error_outline</mat-icon>
        <span>{{ saveError }}</span>
      </div>

      <span class="cf-dlg-section__label">Datos de la caja</span>

      <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingNombre">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nombre</mat-label>
          <input matInput name="nombre" [(ngModel)]="efectivo.nombre" autocomplete="off" cdkFocusInitial>
        </mat-form-field>
        <div class="cf-field__error" *ngIf="submitted && missingNombre"><mat-icon>error</mat-icon> Indica el nombre de la caja</div>
      </div>

      <div class="cf-dlg-row">
        <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingUbicacion">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Ubicación</mat-label>
            <input matInput name="ubicacion" [(ngModel)]="efectivo.ubicacion" autocomplete="off">
          </mat-form-field>
          <div class="cf-field__error" *ngIf="submitted && missingUbicacion"><mat-icon>error</mat-icon> Indica la ubicación</div>
        </div>

        <div>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fondo de caja</mat-label>
            <input type="text" matInput name="fondoDeCaja" [(ngModel)]="efectivo.fondoDeCaja" inputmode="decimal" autocomplete="off" numberDecimalsDirective>
            <span matSuffix class="ef-suffix">€</span>
          </mat-form-field>
        </div>
      </div>

      <div class="ef-uid" *ngIf="isEditMode">
        <button type="button" class="ef-link" (click)="showApiKey = !showApiKey">
          <mat-icon>{{ showApiKey ? 'visibility_off' : 'vpn_key' }}</mat-icon>
          {{ showApiKey ? 'Ocultar UID' : 'Ver UID' }}
        </button>
        <span *ngIf="showApiKey" class="ef-uid__value">{{ efectivo.uid }}</span>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cancelar</button>
      <button type="submit" mat-flat-button class="cf-dlg-btn-primary">
        <mat-icon>save</mat-icon> {{ isEditMode ? 'Guardar cambios' : 'Crear caja' }}
      </button>
    </div>
  </form>
</div>
